import React, { useState } from "react";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import { useCopyPostLinkMutation } from "../misc/mutations";
import { getFEURL } from "../../Helpers/utils";

interface SharePostProps {
  postId: number;
}

export const SharePost: React.FC<SharePostProps> = ({ postId }) => {
  const [showShare, setShowShare] = useState(false);
  const [shakeIcon, setShakeIcon] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const afterCopyPostId = (encodedPostID: string) => {
    navigator.clipboard.writeText(`${getFEURL()}/post/${encodedPostID}`);
    setOpenSnackbar(true);
    setTimeout(() => setOpenSnackbar(false), 5000); // Hide after 5 seconds
  };

  const getPostEncodedIdMitation = useCopyPostLinkMutation(afterCopyPostId);

  const handleClick = () => {
    setShakeIcon(true);
    getPostEncodedIdMitation.mutate({ postId });
    setTimeout(() => setShakeIcon(false), 500);
  };

  return (
    <>
      <div
        className="flex items-center gap-0.5 cursor-pointer"
        onMouseEnter={() => setShowShare(true)}
        onMouseLeave={() => setShowShare(false)}
        onClick={handleClick}
      >
        <WifiTetheringIcon className={shakeIcon ? "animate-shake" : ""} />
        <span className={showShare ? "inline" : "hidden"}>Share</span>
      </div>
      {openSnackbar && (
        <div
          className="fixed bottom-0 left-0 m-4 p-4 bg-green-50 text-slate-600 rounded hover:bg-green-200 cursor-pointer transition-all duration-300"
          onClick={() => setOpenSnackbar(false)}
        >
          Link copied to clipboard!
        </div>
      )}
    </>
  );
};
